import { CMSTransformerDataType } from 'types/common';
import { Logger, ConfigService } from '@nextgen-web-framework/core';

export const fetchFallback = async (
  section: 'header' | 'footer',
  setHeader: (data: CMSTransformerDataType) => void,
  setFooter: (data: CMSTransformerDataType[]) => void,
  locale: string,
) => {
  const configs = ConfigService.getConfigs();
  const logger = new Logger();
  const url = `/fallback?section=${section}&market=${configs.NEXT_PUBLIC_COUNTRY}&lang=${locale}`;

  try {
    const res = await fetch(url);
    if (!res.ok) throw new Error(`HTTP ${res.status}: ${res.statusText}`);

    const data = await res.json();

    if (section === 'header') {
      setHeader(data?.data?.[0] || null);
    }

    if (
      section === 'footer' &&
      Array.isArray(data?.data) &&
      data.data.some((item: {}) => Object.keys(item).length > 0)
    ) {
      setFooter(data.data);
    }
  } catch (err) {
    logger.log(`Fallback ${section} fetch failed:`, err instanceof Error ? err.message : JSON.stringify(err));
  }
};

export const isEmptyObject = (obj: CMSTransformerDataType) => {
  return !obj || (typeof obj === 'object' && Object.keys(obj).length === 0);
};
